/*
 * Loads a card's hover image the first time it is actually needed.
 *
 * card-product.liquid renders the second photo with data-srcset/data-src and no
 * real source, so it costs nothing until a pointer or keyboard focus reaches
 * the card. A touch device never hovers, so it never downloads them at all.
 *
 * Delegated from the document, so cards added later — sliders, infinite scroll,
 * Section Rendering API — are covered without any per-card setup.
 */
(function () {
  var ATTR = '[data-plush-hover-image]';

  function reveal(card) {
    card.querySelectorAll(ATTR).forEach(function (img) {
      var srcset = img.getAttribute('data-srcset');
      var src = img.getAttribute('data-src');
      if (src) img.src = src;
      if (srcset) img.srcset = srcset;
      img.removeAttribute('data-plush-hover-image');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    });
  }

  function onEnter(event) {
    var card = event.target.closest && event.target.closest('.card-wrapper');
    if (card && card.querySelector(ATTR)) reveal(card);
  }

  // pointerover covers mouse and pen; a touch "hover" fires it too, at which
  // point the image is genuinely about to matter.
  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter);
})();
